var map = {
	"./common/Waving_Hand.png": "c9dc",
	"./common/apply-tips.png": "2d13",
	"./common/apply.png": "3c11",
	"./common/avatar.jpg": "cb77",
	"./common/blue-background.jpg": "07b0",
	"./common/business-overview/applyCount.png": "d434",
	"./common/business-overview/enrolment.png": "a1c4",
	"./common/business-overview/studentCount.png": "7d59",
	"./common/company-seal.png": "4834",
	"./common/default-logo.png": "ee50",
	"./common/detail-info.png": "9e11",
	"./common/detail-lang.png": "ad56",
	"./common/e-signature.png": "7d67",
	"./common/file-uploaded.png": "a7d4",
	"./common/forget-pwd-bg.png": "2bbb",
	"./common/frame_1_background.png": "8b17",
	"./common/gopro.png": "6183",
	"./common/green-passport.jpg": "b8d5",
	"./common/green.jpg": "4018",
	"./common/login-bg-left2.png": "ce33",
	"./common/login-bg.jpg": "335c",
	"./common/login-bg.png": "9d20",
	"./common/logo-all.png": "6c9b",
	"./common/logo-has-text.gif": "0584",
	"./common/logo.png": "bae8",
	"./common/no-data.png": "105e",
	"./common/orange-idcard.jpg": "9293",
	"./common/orange.jpg": "cf67",
	"./common/passport_en-us.png": "3d0d",
	"./common/passport_zh-hk.png": "b56c",
	"./common/passport_zh.png": "b218",
	"./common/reset.png": "bc54",
	"./common/search.png": "2980",
	"./common/signature-sample-bg.png": "2f0f",
	"./common/signature-sample-bg_en.png": "052e",
	"./common/signature-sample1.png": "6ebd",
	"./common/signature-sample1_en.png": "1df0",
	"./common/signature-sample2.png": "efe7",
	"./common/signature-sample2_en.png": "a65b",
	"./common/statistics-no-data.png": "8344",
	"./common/status/frame_1_icon.png": "ec54",
	"./common/status/frame_2_icon.png": "18a4",
	"./common/status/frame_3_icon.png": "8a8c",
	"./common/status/frame_4_icon.png": "23dc",
	"./common/status/frame_5_icon.png": "f0ba",
	"./common/status/frame_6_icon.png": "c8b9",
	"./common/status1.png": "e006",
	"./common/status2.png": "8e27",
	"./common/status3.png": "a139",
	"./common/status4.png": "b5af",
	"./common/status5.png": "50e7",
	"./common/stu-info-regst-l.jpg": "147e",
	"./common/stu-info-regst-r.jpg": "b819",
	"./common/student-default-avatar.png": "c5b3",
	"./common/student.png": "021e",
	"./common/student_title_bankground.png": "ab6d",
	"./common/summary-item-bg.png": "f11e",
	"./common/system-noice.gif": "18f4",
	"./common/top9/1.png": "5e23",
	"./common/top9/2.png": "151e",
	"./common/top9/3.png": "23d5",
	"./common/top9/4.png": "2160",
	"./common/top9/5.png": "ebe2",
	"./common/top9/6.png": "bce6",
	"./common/top9/7.png": "4edd",
	"./common/top9/8.png": "899a",
	"./common/top9/9.png": "2a1a",
	"./common/top9/applyCount.png": "242e",
	"./common/top9/enrolment.png": "0cd8",
	"./common/top9/studentCount.png": "aacd",
	"./common/top9/top9-left.png": "dc22",
	"./common/top9/top9-right.png": "dd0f",
	"./common/video-img.png": "7be9",
	"./error/error.png": "3484",
	"./files-icon/AUTHORIZATION_LETTER.png": "5685",
	"./files-icon/BACHELOR_DEGREE.png": "3c63",
	"./files-icon/CAS_BRP.png": "6771",
	"./files-icon/CV.png": "d151",
	"./files-icon/DSE_TRANSCRIPT.png": "efca",
	"./files-icon/GRADUATION_CERTIFICATE.png": "9cd8",
	"./files-icon/INTERNSHIP_CERTIFICATE.png": "d049",
	"./files-icon/OTHERS.png": "82d9",
	"./files-icon/PASSPORT.png": "7290",
	"./files-icon/PS.png": "c8cd",
	"./files-icon/REFERENCE_LETTER_1.png": "31f7",
	"./files-icon/REFERENCE_LETTER_2.png": "10c8",
	"./files-icon/STUDY_CERTIFICATE.png": "bc5a",
	"./files-icon/TOEFL.png": "95f1",
	"./files-icon/TRANSCRIPT.png": "8234",
	"./mps/common_icon.png": "0524",
	"./mps/country_4.png": "c39c",
	"./mps/country_5.png": "a9db",
	"./mps/country_6.png": "4da8",
	"./mps/country_7.png": "34c3",
	"./mps/hot_click_background.png": "d920",
	"./mps/hot_icon.png": "ec3f",
	"./mps/nation_background.png": "f014",
	"./mps/new_background.png": "b9b2",
	"./mps/new_icon.png": "bebc",
	"./mps/recommend_icon.png": "920b",
	"./mps/reset.png": "465e",
	"./mps/title_background.png": "1566",
	"./quick-access/applicationFee.png": "7609",
	"./quick-access/applicationList.png": "8dbe",
	"./quick-access/businessOverview.png": "6944",
	"./quick-access/businessStatistics.png": "7de7",
	"./quick-access/contactPerson.png": "cb8d",
	"./quick-access/financialSettlement.png": "3732",
	"./quick-access/institutionInfo.png": "5b2c",
	"./quick-access/mpsManagement.png": "2310",
	"./quick-access/resourceManagement.png": "98ea",
	"./quick-access/setting.png": "d970",
	"./quick-access/studentQuery.png": "6c9d",
	"./quick-access/studentRegister.png": "8459",
	"./resource/aus.png": "a2c6",
	"./resource/ca.png": "9b4b",
	"./resource/download-gear-form.png": "cf3f",
	"./resource/gear-online-form-btn.png": "1b3a",
	"./resource/icon_1.png": "54eb",
	"./resource/icon_2.png": "3119",
	"./resource/icon_3.png": "00ec",
	"./resource/ireland.png": "a107",
	"./resource/mark.png": "4237",
	"./resource/pull_down.png": "d395",
	"./resource/title.png": "1585",
	"./resource/title_background.png": "f30f",
	"./resource/uk.png": "7c6f",
	"./resource/us.png": "4072"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e107";